const WIKI_SEARCH = "https://oldschool.runescape.wiki/w/Special:Search?search=";

// Build the most relevant OSRS Wiki page/guide link for a given task.
export function taskWikiUrl(task) {
  if (!task) return null;
  const m = task.meta || {};
  const v = m.verify || {};
  const cat = task.category;
  let term;
  if (cat === "skilling") term = `${v.skill || m.skill || ""} training`;
  else if (cat === "quests") term = v.name || v.quest || (task.title || "").replace(/^Complete /, "");
  else if (cat === "diaries") term = `${v.region || ""} Achievement Diary`;
  else if (cat === "clues") term = `${m.tier || ""} clue scroll`;
  else if (cat === "combat" || cat === "collection")
    term = v.activity || m.activity || (v.type === "combat_level" ? "Combat level" : task.title);
  else term = task.title;
  term = (term || task.title || "").trim();
  if (!term) return null;
  return WIKI_SEARCH + encodeURIComponent(term);
}
